import React from 'react';

const LoadingView = () => (
  <div className="preloader">
    <img src="/icons/dyzio-icon.svg" alt="Loading" />
  </div>
);

export default LoadingView;



// WEBPACK FOOTER //
// ./src/components/loading/index.js